import { useEffect, useState, useCallback } from 'react';

/** Détecte la capacité d'installation PWA (Chrome/Android/Edge) et le contexte iOS Safari
 * (qui n'a pas d'API d'installation native — il faut guider l'utilisateur manuellement). */
export function usePWAInstall() {
  const [deferredEvent, setDeferredEvent] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    setIsStandalone(
      window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
    );
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredEvent(e);
    };
    const onInstalled = () => setDeferredEvent(null);
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  const canPromptInstall = !!deferredEvent;
  const canInstall = !isStandalone && (canPromptInstall || isIOS);

  const promptInstall = useCallback(async () => {
    if (!deferredEvent) return false;
    deferredEvent.prompt();
    const { outcome } = await deferredEvent.userChoice;
    setDeferredEvent(null);
    return outcome === 'accepted';
  }, [deferredEvent]);

  return { canInstall, canPromptInstall, isIOS, isStandalone, promptInstall };
}

export default usePWAInstall;
